export const generatePlaceholderSVG = (text, width = 400, height = 400, bgColor = '#6677aa', subtitle = null) => {
  // Escape XML special characters
  const escapeXML = (str) => {
    if (!str) return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  };
  
  // Handle main text and subtitle separately
  const mainText = escapeXML(Array.isArray(text) ? text[0] : text);
  const subText = escapeXML(subtitle || (Array.isArray(text) && text[1] ? text[1] : null));
  
  // Split main text into lines if too long
  // Adjust character calculation based on width - smaller widths need smaller divisor
  const padding = 20; // Add padding to prevent edge cropping
  const effectiveWidth = width - (padding * 2);
  const charDivisor = width < 350 ? 8 : 12;
  const maxCharsPerLine = Math.floor(effectiveWidth / charDivisor);
  const words = mainText.split(' ');
  const lines = [];
  let currentLine = '';
  
  words.forEach(word => {
    if ((currentLine + ' ' + word).length <= maxCharsPerLine) {
      currentLine = currentLine ? currentLine + ' ' + word : word;
    } else {
      if (currentLine) lines.push(currentLine);
      currentLine = word;
    }
  });
  if (currentLine) lines.push(currentLine);
  
  // Calculate font sizes - smaller for narrow placeholders
  const totalLines = lines.length + (subText ? 1.5 : 0);
  const baseFontSize = width < 350 ? 14 : 18;
  const mainFontSize = Math.min(baseFontSize, Math.floor(height / (totalLines * 2.2)));
  const subFontSize = mainFontSize * 0.8;
  const lineHeight = mainFontSize * 1.5;
  
  // Calculate vertical positioning
  const totalHeight = lines.length * lineHeight + (subText ? subFontSize * 2 : 0);
  const startY = (height - totalHeight) / 2 + mainFontSize;
  
  // Create SVG string (lines and subText are already escaped)
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
      <rect width="${width}" height="${height}" fill="${bgColor}"/>
      ${lines.map((line, i) => `
        <text x="${width/2}" y="${startY + i * lineHeight}" 
              font-family="Arial, sans-serif" 
              font-size="${mainFontSize}" 
              fill="white" 
              text-anchor="middle">
          ${line}
        </text>
      `).join('')}
      ${subText ? `
        <text x="${width/2}" y="${startY + lines.length * lineHeight + subFontSize}" 
              font-family="Arial, sans-serif" 
              font-size="${subFontSize}" 
              fill="#ccddff" 
              font-weight="bold"
              text-anchor="middle">
          ${subText}
        </text>
      ` : ''}
    </svg>
  `;
  
  // Convert to data URL
  const svgBase64 = btoa(unescape(encodeURIComponent(svg)));
  return `data:image/svg+xml;base64,${svgBase64}`;
};